<p-toast></p-toast>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-fieldset>

    <ng-template pTemplate="header"></ng-template>
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="redirectSchoolList()"></button>
        </ng-template>
    </p-toolbar>

    <!-- Main Card -->
    <div class="card">
        <!-- Grid -->

        <!-- INFO SECTION -->
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <div class=" p-fluid">
                    <h5 class="p-md-6">{{translations.lbl_record}} {{translations.lbl_school_prep_guides}}</h5>

                    <!-- Input NAME -->
                    <div class="p-field p-col-12 p-md-12">
                        <div class="p-col-12">
                            <label for="selectedNameInput">{{translations.lbl_name}}<span *ngIf="!selectedName"
                                    [ngStyle]="{ 'color': selectedName ? '' : 'red' }"> </span></label>
                            <input id="selectedNameInput" [(ngModel)]="selectedName" type="text" maxlength="30"
                                pInputText>
                        </div>
                    </div>

                </div>
            </div>

        </div>

        <!-- INFO SECTION -->
        <div class="p-grid">

            <!-- 1st Section -->
            <div class="p-col-12 p-md-6">
                <div class="p-fluid">
                    <h5 class="p-md-6">{{translations.lbl_place_where_provide}}</h5>

                    <!-- CORDINATION -->
                    <div class="p-col-12">
                        <label for="listStore">
                            {{translations.lbl_coordination}}:</label>
                        <p-dropdown id="listStore" [options]="listStore" [(ngModel)]="selectedStore"
                            placeholder="{{translations.lbl_select}} Coordinacion" optionLabel="descri"
                            [showClear]="true" [filter]="true" (onChange)="getGuidesByStore()"
                            [disabled]="true"></p-dropdown>
                    </div>


                    <!-- Input State  -->
                    <div class="p-col-12">
                        <label for="selectedStateInput">{{translations.lbl_state}} <span *ngIf="!selectedState"
                                [ngStyle]="{ 'color': selectedState ? '' : 'red' }"> </span></label>
                        <p-dropdown id="selectedStateInput" [options]="listState" [(ngModel)]="selectedState"
                            placeholder="{{translations.lbl_select}} {{translations.lbl_state}}" optionLabel="descrip"
                            [showClear]="true" [filter]="true" (onChange)="getChurches()"
                            [disabled]="canEditComponent"></p-dropdown>
                    </div>

                    <!-- Church -->
                    <div class="p-col-12">
                        <label for="selectedChurchInput">{{translations.lbl_church_name}} <span *ngIf="!selectedChurch"
                                [ngStyle]="{ 'color': selectedChurch ? '' : 'red' }"> </span></label>
                        <p-autoComplete id="selectedChurchInput" [(ngModel)]="selectedChurch"
                            [suggestions]="filteredChurchs" (completeMethod)="filterChurch($event)" field="name"
                            [minLength]="1" [dropdown]="true" [disabled]="canEditComponent"></p-autoComplete>
                    </div>

                    <!-- <pre>{{ security | json}}</pre> -->

                    <!-- Date -->
                    <div class="p-col-12">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <!-- Year -->
                            <div class="p-col-12 p-md-6">
                                <label for="selectedYearInput">{{translations.lbl_year}} <span *ngIf="!selectedYear"
                                        [ngStyle]="{ 'color': selectedYear ? '' : 'red' }"> </span></label>
                                <p-inputNumber id="selectedYearInput" [(ngModel)]="selectedYear"
                                    inputId="withoutgrouping" [useGrouping]="false" [showButtons]="true"
                                    [showButtons]="true" [min]="currentYear-3" [max]="currentYear+3"
                                    [disabled]="this.security?.levelId === undefined || this.security?.levelId === null|| this.security.levelId != 'Z'"></p-inputNumber>
                            </div>

                            <!-- Period -->
                            <div class="p-col-12 p-md-6">
                                <label for="selectedPeriodInput">{{translations.lbl_period}} <span
                                        *ngIf="!selectedPeriod" [ngStyle]="{ 'color': selectedPeriod ? '' : 'red' }">
                                    </span></label>
                                <p-inputNumber id="selectedPeriodInput" [(ngModel)]="selectedPeriod" inputId="minmax"
                                    mode="decimal" [min]="1" [max]="2" [showButtons]="true"
                                    [disabled]="this.security?.levelId === undefined || this.security?.levelId === null|| this.security.levelId != 'Z'"></p-inputNumber>
                            </div>
                        </div>
                    </div>

                    <!-- Type -->
                    <div class="p-col-12">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <!-- Workshop List -->
                            <div class="p-col-12 p-md-6">
                                <label for="typeServiceInput">{{translations.lbl_type}} {{translations.lbl_workshop}}
                                </label>
                                <input [disabled]="true" id="typeServiceInput"
                                    value="{{translations.lbl_school_prep_guides}}" type="text" maxlength="30"
                                    pInputText>
                            </div>
                            <!-- Language -->
                            <div class="p-col-12 p-md-6">
                                <label for="listLanguage">{{translations.lbl_language}} <span *ngIf="!selectedLanguage"
                                        [ngStyle]="{ 'color': selectedLanguage ? '' : 'red' }"> </span></label>
                                <p-dropdown [options]="listLanguage" [(ngModel)]="selectedLanguage"
                                    placeholder="{{translations.lbl_select}} {{translations.lbl_language}}"
                                    optionLabel="value" [showClear]="true" [disabled]="canEditComponent"></p-dropdown>
                            </div>
                        </div>
                    </div>


                    <!-- 1st Guide  -->
                    <div class="p-col-12">
                        <label for="selectedGuideStore1Input">1° {{translations.lbl_guide}} : <span
                                *ngIf="!selectedGuideStore1" [ngStyle]="{ 'color': selectedGuideStore1 ? '' : 'red' }">
                            </span></label>
                        <p-dropdown id="selectedGuideStore1Input" [options]="listGuidesStore1"
                            [(ngModel)]="selectedGuideStore1"
                            placeholder="{{translations.lbl_select}} 1° {{translations.lbl_guide}}"
                            optionLabel="fullName" [filter]="true" [readonly]="false"
                        ></p-dropdown>
                    </div>

                    <!-- 2nd Guide  -->
                    <div class="p-col-12" *ngIf="visibleMateGuide">
                        <label *ngIf="visibleMateGuide" for="listGuidesStore2Input">
                            {{translations.lbl_mate_guide_refunding}}:</label>
                        <p-dropdown id="listGuidesStore2Input" *ngIf="visibleMateGuide" [options]="listGuidesStore2"
                            [(ngModel)]="selectedGuideStore2"
                            placeholder="{{translations.lbl_select}} 2° {{translations.lbl_guide}}"
                            optionLabel="fullName" [showClear]="true" [filter]="true"></p-dropdown>
                    </div>


                </div>
            </div>

            <!-- 2nd Section -->
            <div class="p-col-12 p-md-6">
                <div class="p-fluid">
                    <h5 class="p-md-6">{{translations.lbl_planning}}</h5>

                    <!-- TIME -->
                    <div class="p-col-12">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <!-- PLANED TIME TIME -->
                            <div class="p-col-12 p-md-4">
                                <label for="plannedDateInput">{{translations.lbl_planned_date}}<span *ngIf="!planedDate"
                                        [ngStyle]="{ 'color': planedDate ? '' : 'red' }"> </span></label>
                                <p-calendar id="plannedDateInput" [(ngModel)]="planedDate" [touchUI]="true"
                                    [readonlyInput]="true" inputId="touchui" dateFormat="yy-mm-dd"
                                    [disabled]="canEditComponent" (onFocus)="onUpdateMinMaxByPeriodYear()"
                                    [maxDate]="maxDate" [minDate]="minDate"></p-calendar>
                            </div>
                            <div class="p-col-12 p-md-4">
                                <label for="startTime">{{translations.lbl_starting_time}} <span *ngIf="!startTime"
                                        [ngStyle]="{ 'color': startTime ? '' : 'red' }"> </span></label>
                                <p-calendar [(ngModel)]="startTime" [timeOnly]="true" inputId="timeonly"
                                    (onSelect)="onSelectInitialTime()" (onClose)="onSelectInitialTime()"
                                    [disabled]="canEditComponent"></p-calendar>
                            </div>
                            <div class="p-col-12 p-md-4">
                                <label for="endTime">{{translations.lbl_ending_time}} <span *ngIf="!endTime"
                                        [ngStyle]="{ 'color': startTime ? '' : 'red' }"> </span></label>
                                <p-calendar [(ngModel)]="endTime" [timeOnly]="true" inputId="timeonly"
                                    [disabled]="true"></p-calendar>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12" style="border: 1px solid #FFF;">
                        <p-table responsive="true" #dt [value]="lstValuesStage" [columns]="lstColsStage">

                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th *ngFor="let col of columns">{{col.header}}</th>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="body" let-data>
                                <tr [pSelectableRow]="data">
                                    <td> {{data.stageNum ? data.stageNum : 'S/N'}} </td>
                                    <td> {{data.wrksId ? data.wrksId : 'S/N'}} </td>
                                    <td> {{data.startDate ? formatDate(data.startDate) : 'S/N'}} </td>
                                    <td> {{data.endDate ? formatDate(data.endDate) : 'S/N'}} </td>
                                    <td> {{data.status ? data.status : 'S/N'}} </td>
                                    <td>
                                        <button pButton pRipple icon="pi pi-calendar-plus" 
                                            class="p-button-rounded p-button-info p-mr-2"
                                            (click)="openSchoolFpgWorkshopAssistence(data)" 
                                            pTooltip="{{translations.lbl_attendance}}"></button>
                                        <button pButton pRipple icon="pi pi-pencil"
                                            class="p-button-rounded p-button-warning p-mr-2"
                                            (click)="openSchoolFpgWorkshopDetail(data)"
                                            pTooltip="{{translations.lbl_edit}}"></button>
                                    </td>
                                </tr>
                            </ng-template>

                            <!-- EMPTY -->
                            <ng-template pTemplate="emptymessage" let-columns>
                                <tr>
                                    <td [attr.colspan]="columns ? columns.length : 1">
                                        {{translations.lbl_no_records_found}}
                                    </td>
                                </tr>
                            </ng-template>


                        </p-table>
                    </div>

                    <!-- ANALYTICS -->
                    <!--div class="p-col-12 ">
                        <div class=" p-fluid p-formgrid p-grid">

                            <div class="p-col-12 p-md-3">
                                <label for="registerFutureGuideInput">{{translations.lbl_participants}}</label>
                                <input id="registerFutureGuideInput" [(ngModel)]="registerFutureGuide" type="text"
                                    pInputText [disabled]="true" />
                            </div>
                           
                            <div class="p-col-12 p-md-3">
                                <label for="firstStageFutureGuideInput">{{translations.lbl_stage}} 1</label>
                                <input id="firstStageFutureGuideInput" [(ngModel)]="firstStageFutureGuide" type="text"
                                    pInputText [disabled]="true" />
                            </div>
                            
                            <div class="p-col-12 p-md-3">
                                <label for="secondStageFutureGuideInput">{{translations.lbl_stage}} 2</label>
                                <input id="secondStageFutureGuideInput" [(ngModel)]="secondStageFutureGuide" type="text"
                                    pInputText [disabled]="true" />
                            </div>
                            
                            <div class="p-col-12 p-md-3">
                                <label for="thirdStageFutureGuideInput">{{translations.lbl_stage}} 3</label>
                                <input id="thirdStageFutureGuideInput" [(ngModel)]="thirdStageFutureGuide" type="text"
                                    pInputText [disabled]="true" />
                            </div>
                        </div>
                    </div-->

                </div>
            </div>
        </div>


        <!-- BUTTONS -->
        <div class="p-grid">
            <div class="p-col-12 p-md-6"></div>
            <div class="p-col-12 p-md-6">
                <!-- Buttons -->
                <div class="p-col-12">
                    <div class=" p-fluid p-formgrid p-grid church_field">
                        <div class="p-col-12 p-md-4"></div>
                        <div class="p-col-12 p-md-4">
                            <div class="p-field">
                                <button pButton pRipple type="button" icon="pi pi-plus"
                                    label="{{translations.lbl_save}}" class="p-button-raised p-button-success"
                                    *ngIf="this.schoolFpgDetail == null || this.schoolFpgDetail.schoolFPG.status!='C'"
                                    (click)="saveSchoolFpgConfirmation()"></button>

                            </div>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <div class="p-field">
                                <button pButton pRipple type="button" icon="pi pi-trash"
                                    label="{{translations.lbl_delete_record}}"
                                    *ngIf="this.schoolFpgDetail == null || this.schoolFpgDetail.schoolFPG.status!='C'"
                                    class="p-mr-2 p-mb-2 p-button-raised p-button-danger" (click)="deleteSchoolFpg()"
                                    [disabled]="this.schoolFpgDetail == null ? true : false"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-fieldset>